import m2_examRegMenu from '@components/excuseMenu/m2_examRegMenu.vue'
import m1_examRegMenu from '@components/excuseMenu/m1_examRegMenu.vue'
import m1_subExamRegMenu from '@components/subExamRegMenu/m1_subExamRegMenu.vue'
import m2_subExamRegMenu from '@components/subExamRegMenu/m2_subExamRegMenu.vue'
import ruleFormCom from "@components/tableRuleForm/tableRuleForm";

import "@assets/js/pinyinUtil";
import m2Sidebar from "@components/sidebar/m2_sidebar";
export default {
  components: {
    'm2ExamRegMenu': m2_examRegMenu,
    "m2Sidebar": m2Sidebar,
    "m1ExamRegMenu": m1_examRegMenu,
    "m1SubExamRegMenu": m1_subExamRegMenu,
    "m2SubExamRegMenu": m2_subExamRegMenu,
    'ruleFormCom': ruleFormCom

  },
  data() {
    return {
      DateOpt: {
        disabledDate: time => {
          let isDate = new Date(this.$common.formatDate(time, "yyyy-MM-dd"));
          if (this.dateLimit.begin_datetime) {
            if (this.dateLimit.end_datetime) {
              return (
                isDate.getTime() >
                new Date(this.dateLimit.end_datetime).getTime() ||
                isDate.getTime() <
                new Date(this.dateLimit.begin_datetime).getTime()
              );
            }
            return (
              isDate.getTime() <
              new Date(this.dateLimit.begin_datetime).getTime()
            );
          }
          if (this.dateLimit.end_datetime) {
            return (
              isDate.getTime() > new Date(this.dateLimit.end_datetime).getTime()
            );
          }
        }
      },
      validCardId: (rule, value, callback) => {
        var cardType = null;
        this.ruleForm.field.forEach(item => {
          if (item._item_type == "cert_type") {
            cardType = item.value;
          }
        });
        if (cardType == "居民身份证") {
          if (!this.$common.validateChinaCt(value)) {
            callback(new Error("证件号码不正确"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      },
      validZipCode: (rule, value, callback) => {
        var re = /^[0-9]{6}$/;
        if (re.test(value)) {
          callback();
        } else {
          callback(new Error("邮政编码不正确"));
        }
      },
      validMobileNum: (rule, value, callback) => {
        if (value != "") {
          if (this.isMobileChange) {
            if (this.$common.validMobileNum(value)) {
              callback();
            } else {
              callback(new Error("手机号不正确"));
            }
          } else {
            callback();
          }
        } else {
          callback();
        }
      },
      validEmail: (rule, value, callback) => {
        if (value != "") {
          if (this.isEmailChange) {
            if (this.$common.validEmail(value)) {
              callback();
            } else {
              callback(new Error("邮箱号不正确"));
            }
          } else {
            callback();
          }
        } else {
          callback();
        }
      },
      ruleForm: {
        field: []
      },
      dateLimit: {},
      promiseState: 0,
      batchNum: 0,
      btnDisable: false,
      operatorTableIndex: "", //当前操作的表格index
      editTableRowIdx: "", //当前操作的表格value值index
      tableRuleForm: {
        field: []
      },
      btnName: "add", //add为添加，edit为编辑
      dialogVisible: false,
      dialogVisible: false,
      fieldImg: [],
      arr: [1, 2, 3, 4, 5],
      isMobileChange: false,
      isEmailChange: false,
    };
  },
  methods: {
    handleEncryption(item) {
      if (item._item_type == "mobile_num") {
        this.isMobileChange = true;
      } else if (item._item_type == "email") {
        this.isEmailChange = true;
      }
    },
    getImgUrl: function (proc_id) {
      return new Promise((resolve, reject) => {
        if (proc_id) {
          this.$http
            .get(globalProvider.serviceUrl("oss/_f/g/lk/dl/{proc_id}"), {
              params: {
                proc_id: proc_id
              }
            })
            .then(data => {
              if (data.body.code == resultCode.Success) {
                let link = data.body.data[0].link;
                resolve(link);
              }
            });
        }

      });
    },
    getFileUrl: function (proc_id) {
      return new Promise((resolve, reject) => {

        this.$http
          .get(globalProvider.serviceUrl("oss/_f/g/lk/dl/{proc_id}"), {
            params: {
              proc_id: proc_id
            }
          })
          .then(data => {
            if (data.body.code == resultCode.Success) {
              let file = [];
              for (let item of data.body.data) {
                file.push({
                  file_id: item.file_guid,
                  name: item.name,
                })
              }
              resolve(file);
            }
          });
      });
    },
    getData: function () {
      let examRegInfo = JSON.parse(JSON.stringify(this.$store.state.examRegInfo.examRegInfo));
      if (examRegInfo === null) {
        this.$router.push({
          name: "excuseExam.chooseBatch"
        });
      }
      examRegInfo.text_info_confs.forEach(item => {
        if (item._item_type == "name" && !item.py_value) {
          this.getPinYIn(item);
        }
        if (item.type == 4) {
          item.value = item.value;
        }
        if (item.type == 7) {
          if (typeof item.value == "string") {
            item.value = item.value.split("/");
          }
        }
      });
      let text_info_confs = examRegInfo.text_info_confs;
      // 将type8类型置于最后
      text_info_confs = this.moveMaxType(text_info_confs);
      // this.ruleForm.field = examRegInfo.text_info_confs;
      this.ruleForm.field = JSON.parse(JSON.stringify(examRegInfo.text_info_confs));
      this.ruleForm.field.map(async item => {
        if (item.type == 8) {
          let results = item.sections.map(async (itemS, index) => {
            return await this.asyncInitialPic(itemS, item.value);
          });
        }
      });
    },
    moveMaxType: function (arr) {
      let maxTypeArr = [];
      arr.map((item, idx, arr) => {
        if (item.type == 8) {
          maxTypeArr.push(item);
          arr.splice(idx, 1);
        }
      });
      arr.push(...maxTypeArr);
      return arr;
    },
    changePy(item) {
      item.py_value = item.py_value.toUpperCase();
      this.field.splice(this.field.indexOf(item), 1, item);
    },
    addTableInfo(item) {
      if (item.value.length < item.sub_confs[0].upper_limit) {
        this.operatorTableIndex = item.index;
        this.tableRuleForm.field = item.sections;
        this.tableRuleForm.field.forEach(item => {
          item.value = '';
        })
        this.btnName = "add";
        this.dialogVisible = true;
      } else {
        this.$alert("超出采集数量上限", {
          confirmButtonText: "确定",
        })
      }
    },
    delTableRow(idx, row, item) {
      this.$confirm("是否确定删除？", "提示信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.editTableRowIdx = idx;
          this.operatorTableIndex = item.index;
          this.ruleForm.field.map(item => {
            if (item.index == this.operatorTableIndex) {
              item.value.splice(this.editTableRowIdx, 1);
            }
          });
        })
        .catch(() => { });
    },
    async asyncInitialPic(itemS, val) {
      if (itemS.type == 6 || itemS.type == 5) {
        if (itemS.type == 6) {
          val.forEach(async i => {
            for (let tag in i) {
              if (itemS.tag == tag) {
                let t = i[tag];
                if (typeof t != 'object') {
                  let link = await this.getImgUrl(t);
                  i[tag] = {
                    proc_id: t,
                    link: link
                  }
                }

              }
            }
          })
        } else if (itemS.type == 5) {
          val.forEach(async i => {

            for (let tag in i) {
              if (itemS.tag == tag) {
                let t = i[tag];
                if (typeof t != 'object') {
                  let file = await this.getFileUrl(t);
                  i[tag] = {
                    proc_id: t,
                    file: file
                  }
                }

              }
            }
          })
        }

        return new Promise(resolve => {
          resolve(val)
        })
      } else {
        return new Promise(resolve => {
          resolve(val)
        })
      }

    },
    async asyncPic(itemS, val) {
      if (itemS.type == 6 || itemS.type == 5) {
        if (itemS.type == 6) {
          for (let tag in val) {
            if (itemS.tag == tag) {
              let link = await this.getImgUrl(val[tag].proc_id);
              val[tag].link = link;

            }
          }
        } else if (itemS.type == 5) {
          for (let tag in val) {
            if (itemS.tag == tag) {
              let file = await this.getFileUrl(val[tag].proc_id);
              val[tag].file = file;
            }
          }
        }

        return new Promise(resolve => {
          resolve(val)
        })
      } else {
        return new Promise(resolve => {
          resolve(val)
        })
      }

    },

    async getFormData(val) {
      this.dialogVisible = false;
      this.ruleForm.field.map(async item => {
        if (item.index == this.operatorTableIndex) {
          let results = item.sections.map(async (itemS, index) => {
            return await this.asyncPic(itemS, val);

          });
          Promise.all(results).then((posts) => {
            if (this.btnName == "add") {
              if (item.value) {
                item.value.push(posts[posts.length - 1]);
              } else {
                item.value = [];
                item.value.push(posts[posts.length - 1]);
              }

            } else {
              item.value.splice(this.editTableRowIdx, 1, posts[posts.length - 1]);
            }
          }).catch(function (reason) {
            // ...
          });
        }
      });
      if (!val) {
        this.tableRuleForm.field = [];
      }
    },
    editTableRow(idx, row, item) {
      this.editTableRowIdx = idx;
      this.operatorTableIndex = item.index;
      item.sections.forEach(item => {
        Object.keys(row).forEach(key => {
          if (key == item.tag) {
            if (item.type != 5 && item.type != 6) {
              item.value = row[key];
            } else {
              item.value = row[key].proc_id
            }
          }
        });
      });
      this.tableRuleForm.field = item.sections;
      this.btnName = "edit";
      this.dialogVisible = true;
    },
    handleClose(val) {
      this.dialogVisible = val;
    },
    displayRule(item) {
      if (item.rules.length > 0) {
        for (let i of item.rules) {
          for (let j of this.ruleForm.field) {
            if (j.tag == i.tag) {
              if (displayRuleType[i.condition]) {
                if (j.type == 3) {
                  let states = true;
                  for (let option of i.value) {
                    if (j.value.indexOf(option) == -1) {
                      states = false;
                    }
                  }
                  if (!states) {
                    item.value = "";
                    item.is_pass = false;
                    return false;
                  }
                } else {
                  if (i.value.indexOf(j.value) == -1) {
                    item.value = "";
                    item.is_pass = false;
                    return false;
                  }
                }
              } else {
                if (!j.value) {
                  item.value = "";
                  item.is_pass = false;
                  return false;
                }
              }
            }
          }
        }
        item.is_pass = true;
        return true;
      } else {
        item.is_pass = true;
        return true;
      }
    },
    setDefaultTime: function (item) {
      let d1 = new Date(item.begin_datetime);
      let d2 = new Date(item.end_datetime);
      if (item.begin_datetime && item.end_datetime) {
        let d3 = new Date((d2.getTime() + d1.getTime()) / 2);
        return d3;
      } else if (item.begin_datetime) {
        let d3 = new Date(d1.getTime() + 3600000 * 24);
        return d3;
      } else if (item.end_datetime) {
        let d3 = new Date(d2.getTime() - 3600000 * 24);
        return d3;
      } else {
        return "";
      }
    },
    setDateLimit: function (item) {
      this.dateLimit = item.sub_confs;
    },
    download: function (file_guid) {
      this.$http.get(globalProvider.serviceUrl('oss/_f/g/lk/dl/single/{file_guid}'), {
        params: {
          file_guid: file_guid
        }
      })
        .then((data) => {
          if (data.body.code == resultCode.Success) {
            try {
              var elemIF = document.createElement("iframe");
              elemIF.src = data.body.data.link;
              elemIF.style.display = "none";
              document.body.appendChild(elemIF);
            } catch (e) {
              zzrw.alert("下载异常！");
            }
          }
        });
    },
    preStep: function () {
      if (this.$store.state.examRegInfo.promiseState) {
        this.$router.push({
          name: "excuseExam.examNotes"
        });
      } else if (this.$store.state.examInfo.batch > 1) {
        this.$router.push({
          name: "excuseExam.chooseBatch"
        });
      }
    },
    getPinYIn: function (item) {
      if (item.sub_confs.enable_pinyin) {
        var n = pinyinUtil.getPinyin(item.value).toUpperCase();
        var j,
          num = 0;
        if (n) {
          for (let i of n.split(" ")) {
            if (n.indexOf(i) == 0 && num == 0) {
              num++;
              j = i + " ";
            } else {
              j = j + i;
            }
          }
        }
        item.py_value = j;
      }
    },
    nextStep: function () {
      this.$store.commit("setBackOrNextStep", "next");
      this.btnDisable = true;
      let infoList = JSON.parse(JSON.stringify(this.ruleForm.field));
      let RegInfoModel = this.$store.state.examRegInfo.examRegInfo;
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {

          let formData = [];
          infoList.forEach(item => {
            if (item.is_pass) {
              if (item.type == 4) {
                formData.push({
                  name: item.name,
                  value: item.value,
                  type: item.type,
                  _item_type: item._item_type,
                  tag: item.tag,
                  is_required: item.is_required
                });
              } else if (item.type == 7) {
                formData.push({
                  name: item.name,
                  value: item.value.join("/"),
                  type: item.type,
                  _item_type: item._item_type,
                  tag: item.tag,
                  is_required: item.is_required
                });
              } else if (item.type == 1 && item.sub_confs.enable_pinyin) {
                formData.push({
                  name: item.name,
                  value: item.value,
                  py_value: item.py_value,
                  type: item.type,
                  _item_type: item._item_type,
                  tag: item.tag,
                  is_required: item.is_required
                });
              } else if (item.type == 8) {
                if (item.value) {
                  item.value.forEach(itm => {
                    Object.keys(itm).forEach(key => {
                      if (typeof itm[key] == 'object') {
                        itm[key] = itm[key].proc_id
                      }
                    })
                  })
                }

                formData.push({
                  name: item.name,
                  value: item.value,
                  type: item.type,
                  _item_type: item._item_type,
                  tag: item.tag,
                  is_required: item.is_required
                });
              } else {
                formData.push({
                  name: item.name,
                  value: item.value,
                  type: item.type,
                  _item_type: item._item_type,
                  tag: item.tag,
                  is_required: item.is_required
                });
              }
            }
          });
          this.$store.commit("setExamRegInfoItem", {
            text_info_confs: infoList
          });
          this.$http
            .post(globalProvider.serviceUrl("ex_exm/us/rgsi/t"), {
              eri: RegInfoModel.exam_registration_id,
              i: formData
            })
            .then(data => {
              this.btnDisable = false;
              if (data.body.code === resultCode.Success) {
                if (RegInfoModel.pic_info_confs.length > 0) {
                  this.$router.push({
                    name: "excuseExam.imgCollection"
                  });
                } else if (RegInfoModel.file_info_confs.length > 0) {
                  this.$router.push({
                    name: "excuseExam.fileCollection"
                  });
                } else {
                  this.$router.push({
                    name: "excuseExam.submitRegInfo"
                  });
                }
              } else if (data.body.code == resultCode.NotSuccess) {
                this.$alert(getErrorMessage(data.body.message), "提示", {
                  confirmButtonText: "确定"
                });
              }
            });
        } else {
          this.btnDisable = false;
        }
      });
    },
    getRules: function (item) {
      // 证件号码验证，仅当证件类型为居民身份证时验证格式
      if (item.type == 1 && item._item_type == "cert_id") {
        if (item.is_required) {
          return [{
            required: true,
            message: item.name + "不能为空",
            trigger: "blur"
          },
          {
            validator: this.validCardId,
            trigger: "blur"
          }
          ];
        } else {
          return [{
            validator: this.validCardId,
            trigger: "blur"
          }];
        }
      }
      if (item.type == 1 && item._item_type == "zip_code" && item.is_required) {
        if (item.is_required) {
          return [{
            required: true,
            message: item.name + "不能为空",
            trigger: "blur"
          },
          {
            validator: this.validZipCode,
            trigger: "blur"
          }
          ];
        } else {
          return [{
            validator: this.validZipCode,
            trigger: "blur"
          }];
        }
      }
      if (item.type == 1 && item._item_type == "mobile_num") {
        if (item.is_required) {
          return [{
            required: true,
            message: item.name + "不能为空",
            trigger: "blur"
          },
          {
            validator: this.validMobileNum,
            trigger: "blur"
          }
          ];
        } else {
          return [{
            validator: this.validMobileNum,
            trigger: "blur"
          }];
        }
      }
      if (item.type == 1 && item._item_type == "email") {
        if (item.is_required) {
          return [{
            required: true,
            message: item.name + "不能为空",
            trigger: "blur"
          },
          {
            validator: this.validEmail,
            trigger: "blur"
          }
          ];
        } else {
          return [{
            validator: this.validEmail,
            trigger: "blur"
          }];
        }
      }
      // 下面4种为标准表单验证
      if (item.type == 1 && item.is_required) {
        return {
          required: true,
          message: item.name + "不能为空",
          trigger: "blur"
        };
      } else if (item.type == 2 && item.is_required) {
        return {
          required: true,
          message: item.name + "不能为空",
          trigger: "change"
        };
      } else if (item.type == 3 && item.is_required) {
        return {
          type: "array",
          required: true,
          message: item.name + "不能为空",
          trigger: "change"
        };
      } else if (item.type == 4 && item.is_required) {
        return {
          required: true,
          message: item.name + "不能为空",
          trigger: "change"
        };
      } else if (item.type == 7 && item.is_required) {
        return {
          type: "array",
          required: true,
          message: item.name + "不能为空",
          trigger: "change"
        };
      }
    },
    getPinyinRules: function (item) {
      if (item.type == 1 && item.sub_confs.enable_pinyin) {
        return {
          required: true,
          message: item.name + "拼音不能为空",
          trigger: "blur"
        };
      }
    }
  },
  created: function () {
    this.$store.commit("setHeaderState", "6");
    this.batchNum = this.$store.state.examInfo.batch;
    this.promiseState = this.$store.state.examRegInfo.promiseState;
    this.getData();
  }
};